type Result<TValue, TError> =
    | {
          failed: false;
          value: TValue;
          error: never;
      }
    | {
          failed: true;
          error: TError;
          value: never;
      };

export default Result;

export function successfulResult<TValue, TError>(value: TValue): Result<TValue, TError> {
    const result: Result<TValue, TError> = {
        failed: false,
        value: value,
        error: undefined as never
    };

    return result;
}

export function failedResult<TValue, TError>(error: TError): Result<TValue, TError> {
    const result: Result<TValue, TError> = {
        failed: true,
        error: error,
        value: undefined as never
    };

    return result;
}
